import Controller from '../shop_product_controller.js'
export default Controller